"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractDate = exports.getUtcDate = exports.getDate = void 0;

var _moment = _interopRequireDefault(require("moment"));
/**
 * Creates a new date object for the given day, month, and year in local time zone
 * @param day the day you wish this object to represent
 * @param month the numeric value of the month
 * @param year the full four digit value of the year
 * @returns A date object corresponding to the new day, month, and year
 */


var getDate = function getDate(day, month, year) {
  return (0, _moment.default)({
    year: year,
    month: month,
    day: day
  });
};
/**
 * Creates a new date object for the given day, month, and year in UTC
 * @param day the day you wish this object to represent
 * @param month the numeric value of the month
 * @param year the full four digit value of the year
 * @returns A date object corresponding to the new day, month, and year
 */


exports.getDate = getDate;

var getUtcDate = function getUtcDate(day, month, year) {
  return _moment.default.utc({
    year: year,
    month: month,
    day: day
  });
};

exports.getUtcDate = getUtcDate;

var extractDate = function extractDate(date, isDateTime) {
  return isDateTime ? (0, _moment.default)(date).format('YYYY-MM-DD') : _moment.default.utc(date).format('YYYY-MM-DD');
};

exports.extractDate = extractDate;